import qs from "qs";
import fp from "lodash/fp";

function queryParamsStringify(object, options = {}) {
    const { addQueryPrefix = false, filterValue = [""], filterKey = [], ...otherOptions } = options;

    let object_ = object;
    if ((Array.isArray(filterValue) && filterValue.length > 0) || (Array.isArray(filterKey) && filterKey.length > 0))
        object_ = fp.pickBy((value, key) => !filterValue.includes(value) && !filterKey.includes(key), object);

    const queryParamString = qs.stringify(object_, {
        arrayFormat: "indices",
        allowDots: true,
        skipNulls: true,
        addQueryPrefix,
        ...otherOptions,
    });
    return queryParamString;
}

export default queryParamsStringify;
